var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4983 24.4377C14.5703 24.4377 17.4584 23.2418 19.6308 21.0704C21.8035 18.8986 23 16.011 23 12.9394C23 8.42763 20.3435 4.31343 16.2321 2.45795L15.8321 3.3444C19.5956 5.04291 22.0274 8.80912 22.0274 12.9393C22.0274 18.7433 17.3041 23.4651 11.4983 23.4651C5.6943 23.4651 0.97248 18.7432 0.97248 12.9393C0.97248 8.80912 3.40431 5.04291 7.1678 3.3444L6.76773 2.45795C2.65655 4.31343 0 8.42763 0 12.9394C0 16.0108 1.19637 18.8984 3.36872 21.0703C5.54063 23.2418 8.42782 24.4377 11.4983 24.4377Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0137 0H11.9862V12.9618H11.0137V0Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/LOGOUT.c38743d86e7b417fba79c400ea3bead8.svg";
export { ForwardRef as ReactComponent };